<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('calendar.schoolEvent') }}</h4>
      <ts-modal-close-button />
    </div>
    <div class="overflow-auto">
      <div id="table-container">
        <ts-table :columns="columns" :records="schoolEvents" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              <span v-if="record.start_date == record.end_date"
                >{{ getDay(record.start_date) }}
                {{ getMonth(record.start_date) }}</span
              >
              <span v-else
                >{{ getDay(record.start_date) }}
                {{ getMonth(record.start_date) }} -
                {{ getDay(record.end_date) }}
                {{ getMonth(record.end_date) }}</span
              >
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.description }}</td>
          </template>
        </ts-table>
      </div>
    </div>
  </ts-card>
</template>
<script>
import moment from 'moment'
export default {
  name: 'school-event',
  data() {
    return {
      loading: false,
      events: []
    }
  },
  computed: {
    schoolEvents() {
      return this.events.filter(ev => ev.event_type.toLowerCase() == 'event')
    },
    columns() {
      return [
        {
          name: this.$t('calendar.date')
        },
        {
          name: this.$t('calendar.name')
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch(
          'calendar/fetchEvent',
          Object.assign(
            {
              year: moment().format('YYYY'),
              month: 0
            },
            { ...attributes }
          )
        )
        .then(response => {
          this.events = response.data
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    getDay(date) {
      if (date) {
        return moment(date).format('DD')
      }
    },
    getMonth(date) {
      if (date) {
        return moment(date).format('MMMM')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#table-container {
  min-height: 50vh;
  max-height: 60vh;
  overflow-y: scroll;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}
</style>
